import { render, staticRenderFns } from "./TransactionForm.vue?vue&type=template&id=54e0163e&scoped=true"
import script from "./TransactionForm.vue?vue&type=script&lang=js"
export * from "./TransactionForm.vue?vue&type=script&lang=js"
import style0 from "./TransactionForm.vue?vue&type=style&index=0&id=54e0163e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e0163e",
  null
  
)

export default component.exports